export default "__VITE_ASSET__DTd7QH4g__"